import { useEffect } from "react";
import Lenis from "lenis";
import { motion, useScroll, useSpring } from "framer-motion";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { Nav } from "@/components/landing/Nav";
import { Hero } from "@/components/landing/Hero";
import { Marquee } from "@/components/landing/Marquee";
import { Axiom } from "@/components/landing/Axiom";
import { Modules } from "@/components/landing/Modules";
import { Showcase } from "@/components/landing/Showcase";
import { Triage } from "@/components/landing/Triage";
import { Stats } from "@/components/landing/Stats";
import { Workflows } from "@/components/landing/Workflows";
import { Exports } from "@/components/landing/Exports";
import { Boundaries } from "@/components/landing/Boundaries";
import { Waitlist } from "@/components/landing/Waitlist";
import { Footer } from "@/components/landing/Footer";
import { Founder } from "@/components/landing/Founder";
import { Explainer } from "@/components/landing/Explainer";
import AdminWaitlist from "@/components/landing/AdminWaitlist";
import { ThemeProvider, useThemeMode } from "@/components/landing/Theme";

const ThemedToaster = (props) => <Toaster theme={useThemeMode().dark ? "dark" : "light"} {...props} />;

const useLenis = () => {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
    const lenis = new Lenis({ lerp: 0.09 });
    let raf;
    const loop = (t) => { lenis.raf(t); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    const onClick = (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (!a) return;
      e.preventDefault();
      lenis.scrollTo(a.getAttribute("href"), { offset: -20 });
    };
    document.addEventListener("click", onClick);
    return () => { cancelAnimationFrame(raf); document.removeEventListener("click", onClick); lenis.destroy(); };
  }, []);
};

const ScrollProgress = () => {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, { stiffness: 120, damping: 30 });
  return <motion.div data-testid="scroll-progress" style={{ scaleX }} className="tri-bar fixed top-0 inset-x-0 h-[3px] origin-left z-[70]" />;
};

function Landing() {
  useLenis();
  return (
    <div className="grain relative overflow-x-clip">
      <ScrollProgress />
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Explainer />
        <Axiom />
        <Modules />
        <Showcase />
        <Triage />
        <Stats />
        <Workflows />
        <Exports />
        <Boundaries />
        <Founder />
        <Waitlist />
      </main>
      <Footer />
      <ThemedToaster position="bottom-right" />
    </div>
  );
}

export default function App() {
  if (window.location.pathname.startsWith("/admin")) return <ThemeProvider><AdminWaitlist /><ThemedToaster /></ThemeProvider>;
  return <ThemeProvider><Landing /></ThemeProvider>;
}
